import { infiniteQueryOptions } from '@tanstack/react-query';
import { config } from 'config';
import { type GetLabelsParams, getLabels } from '~/modules/labels/api';
import { getOffset } from '~/query/helpers';

// Keys for labels queries
export const labelKeys = {
  all: ['labels'] as const,
  table: {
    base: () => [...labelKeys.all, 'table'] as const,
    entries: (filters: GetLabelsParams) => [...labelKeys.all, 'table', filters] as const,
  },
  create: () => [...labelKeys.all, 'create'] as const,
  update: () => [...labelKeys.all, 'update'] as const,
  delete: () => [...labelKeys.all, 'delete'] as const,
};

// Infinite Query Options to get a paginated list of attachments
export const labelsQueryOptions = ({
  q = '',
  projectId,
  sort: initialSort,
  order: initialOrder,
  limit = config.requestLimits.labels,
  orgIdOrSlug,
}: GetLabelsParams) => {
  const sort = initialSort || 'lastUsedAt';
  const order = initialOrder || 'desc';

  const queryKey = labelKeys.table.entries({ orgIdOrSlug, q, sort, order, projectId });

  return infiniteQueryOptions({
    queryKey,
    initialPageParam: 0,
    refetchOnWindowFocus: false,
    queryFn: async ({ pageParam: page, signal }) => {
      const offset = getOffset(queryKey); // Calculate before fetching ensuring correct offset
      return await getLabels({ page, q, sort, order, projectId, limit, offset, orgIdOrSlug }, signal);
    },
    getNextPageParam: (_lastPage, allPages) => allPages.length,
  });
};
